// extracted by mini-css-extract-plugin
module.exports = {"leadStudios":"style_leadStudios__wBMeN","leadStudiosLogo":"style_leadStudiosLogo__1SYgN"};